import Axios from "./AxiosInstance";

export const fetchNotifications = async (params = {}) => {
  const { isRead, limit } = params;
  let url = "/api/notifications";
  const queryParams = [];
  if (isRead !== undefined) queryParams.push(`isRead=${isRead}`);
  if (limit) queryParams.push(`limit=${limit}`);
  if (queryParams.length) url += "?" + queryParams.join("&");
  const res = await Axios.get(url);
  return res.data;
};

export const markAsRead = async (id) => {
  const res = await Axios.put(`/api/notifications/${id}/read`);
  return res.data;
};

export const markAllAsRead = async () => {
  const res = await Axios.put("/api/notifications/read-all");
  return res.data;
};

export const deleteNotification = async (id) => {
  const res = await Axios.delete(`/api/notifications/${id}`);
  return res.data;
};

export const deleteAllNotifications = async () => {
  const res = await Axios.delete("/api/notifications");
  return res.data;
};
